export default __webpack_public_path__ + "static/screenshot_2d-43aec3ae865d43e5825fb91afacfca03.png";